import { IPortalSettings } from "src/app/models/portal.model";
import { ReduxWrapper } from "../app.state";

export class PortalState {
	settings!: IPortalSettings;
}

export const portalSettingsDefaultValue: IPortalSettings = {
	navigation: {
		sidebarnavigation: [],
		topnavigation: [],
		sidebarprofilenavigation: [],
	},
	pages: undefined,
	banners: {
		banner: []
	},
	templatebuilder: {
		sharepoint: [],
		teams: []
	},
	customizer: {
		platforms: []
	},
	pricing: {
		pricingschema: undefined
	}

}

export const portalInitialState: ReduxWrapper<PortalState> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value: {
		settings: portalSettingsDefaultValue
	}
};
